/** --------------------- Interfaces----------------------------  */
// Banner data interface
export interface BannerData {
    id: string,
    message:string,
    startDate:Date | null,
    endDate:Date | null,
    visibility : boolean
}

// User site interface
export interface SiteData {
    id : string,
    label: string,
    value: string
}

// Delete user Response
export interface DeleteResponse {
  Id: string;
  success: boolean;
  error: string;
}

/*  ----------------------- Constants ------------------------------ */
// Banner list table header list
const BANNER_LIST_HEADER = [
    "Message",
    "Start Date",
    "Last Date",
    "Visibility",
    "Actions"
];

// Per page recods
const DATA_PER_PAGE = 100;
const DELETE_CONFIRMATION_TITLE = "Confirm Remove";
const UPDATE_CONFIRMATION_TITLE = "Confirm update";
const DELETE_CONFIRMATION_MSG = "Are you sure you want to delete the selected banner(s)?";
const ERROR_FETCH_BANNER = "Unable to fetch banner details. Please try again.";
const ERROR_UPDATE_BANNER = "Unable to update banner. Please try again.";
const ERROR_ADD_BANNER = "Unable to create banner. Please try again.";
const ERROR_DELETE_BANNER = "Unable to delete banner(s). Please try again.";
const ERROR_FETCH_SITE = "Unable to fetch customer site data. Please try again.";
const BANNER_ADDED = "Banner has been created successfully.";
const BANNER_UPDATED = "Bannerer has been updated successfully.";
const ERROR_Message_REQUIRED = "Message is required.";
const ERROR_DATE_REQUIRED = "Date is required.";
const ERROR_STARTDATE_REQUIRED = "Start date is required.";
const ERROR_ENDDATE_REQUIRED = "End date is required.";
const BANNER_DELETED = "Banner(s) have been deleted successfully.";
const BANNER_DELETED_Confirmation = "Are you sure you want to delete this banner?"
const BANNER_UPDATE_Confirmation = "Are you sure you want to update this banner?"


// Export all constants
export const BannerConstants = {
    BANNER_LIST_HEADER,
    DELETE_CONFIRMATION_TITLE,
    UPDATE_CONFIRMATION_TITLE,
    DELETE_CONFIRMATION_MSG,
    DATA_PER_PAGE,
    ERROR_FETCH_BANNER,
    ERROR_UPDATE_BANNER,
    ERROR_ADD_BANNER,
    ERROR_FETCH_SITE,
    ERROR_DELETE_BANNER,
    BANNER_ADDED,
    BANNER_UPDATED,
    ERROR_Message_REQUIRED,
    ERROR_DATE_REQUIRED,
    BANNER_DELETED,
    ERROR_STARTDATE_REQUIRED,
    ERROR_ENDDATE_REQUIRED,
    BANNER_DELETED_Confirmation,
    BANNER_UPDATE_Confirmation
}
